import template from "./pricing-table.html";

const PricingTableComponent = {
  bindings: {
    pricingTable: "<",
    pricingTableFormInvalid: "=",
    onDismiss: "&",
    onClose: "&",
  },
  template: template,
  controller: class PricingTableController {
    /* @ngInject */
    constructor($rootScope, $scope, $filter, Tariff, QuoteLine, Notification, Utils, ModalsManager, SweetAlertService) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$filter = $filter;
      this.Tariff = Tariff;
      this.QuoteLine = QuoteLine;
      this.NotificationService = Notification;
      this.Utils = Utils;
      this.ModalsManager = ModalsManager;
      this.SweetAlertService = SweetAlertService;
      this.formErrorMessages = {
        description: {
          required: this.$filter("trans")("form.error.required"),
          maxlength: this.$filter("trans")("form.error.tooLong"),
        },
        quantity: {
          required: this.$filter("trans")("form.error.required"),
          number: this.$filter("trans")("pricingTable.form.error.quantity.number"),
          min: this.$filter("trans")("pricingTable.form.error.quantity.min"),
          max: this.$filter("trans")("pricingTable.form.error.quantity.max"),
          maxlength: this.$filter("trans")("pricingTable.form.error.quantity.maxLength"),
        },
        price: {
          required: this.$filter("trans")("form.error.required"),
          number: this.$filter("trans")("pricingTable.form.error.price.number"),
          min: this.$filter("trans")("pricingTable.form.error.price.number"),
          max: this.$filter("trans")("pricingTable.form.error.price.max"),
        },
        margin: {
          required: this.$filter("trans")("form.error.required"),
          number: this.$filter("trans")("pricingTable.form.error.margin.number"),
          max: this.$filter("trans")("pricingTable.form.error.margin.max"),
        },
        discount: {
          number: this.$filter("trans")("pricingTable.form.error.discount.number"),
          max: this.$filter("trans")("pricingTable.form.error.discount.max"),
        },
        costQuantity: {
          required: this.$filter("trans")("form.error.required"),
          number: this.$filter("trans")("pricingTable.form.error.costQuantity.number"),
          min: this.$filter("trans")("pricingTable.form.error.costQuantity.min"),
          max: this.$filter("trans")("pricingTable.form.error.costQuantity.max"),
          maxlength: this.$filter("trans")("pricingTable.form.error.costQuantity.maxLength"),
        },
        taxName: {
          required: this.$filter("trans")("form.error.required"),
          maxlength: this.$filter("trans")("form.error.tooLong"),
        },
        taxPercentage: {
          required: this.$filter("trans")("form.error.required"),
          number: this.$filter("trans")("pricingTable.form.error.taxPercentage.number"),
          max: this.$filter("trans")("pricingTable.form.error.taxPercentage.max"),
          min: this.$filter("trans")("pricingTable.form.error.taxPercentage.min"),
        },
      };
    }

    async $onInit() {
      this.openedCostList = [];
      this.wantExit = false;

      if (this.pricingTable.lines.length === 0) this.addQuoteLine();

      this.taxes = this.$rootScope.organization.settings.taxes.filter((tax) => tax.default);
      this.$rootScope.$applyAsync();

      this.$scope.$watch(
        () => this.form.$invalid,
        (newValue, oldValue) => {
          if (!angular.equals(newValue, oldValue)) this.pricingTableFormInvalid = newValue;
        },
      );
    }

    showError(formField) {
      return formField ? formField.$invalid && (formField.$dirty || this.wantExit) : false;
    }

    messageError(formField, field) {
      if (!this.showError(formField)) return;

      for (const keyError in formField.$error) {
        return this.formErrorMessages[field][keyError];
      }

      return "";
    }

    isValidLine(lineNumber) {
      const validCost = (lineNumber) => {
        for (let i = 0; i < this.pricingTable.lines[lineNumber].costs.length; i++) {
          if (
            this.form["costQuantity_" + lineNumber + "_" + i] &&
            this.form["costQuantity_" + lineNumber + "_" + i].$invalid
          )
            return false;
        }

        return true;
      };

      return (
        this.form["description_" + lineNumber].$valid &&
        this.form["quantity_" + lineNumber].$valid &&
        this.form["price_" + lineNumber].$valid &&
        // Si el margen esta definido en el fomulario y es invalido es el unico caso que debe devolver false
        !(this.form["margin_" + lineNumber] && this.form["margin_" + lineNumber].$invalid) &&
        this.form["discount_" + lineNumber].$valid &&
        validCost(lineNumber)
      );
    }

    searchTariffs(searchText) {
      return this.Tariff.query({ q: searchText });
    }

    copyTariffToQuoteLine(quoteLine, tariff) {
      const currencyFrom = this.$rootScope.organization.settings.currency;
      quoteLine.setDataFromTariff(this.pricingTable.exchangeInfo.rates, currencyFrom, tariff);
    }

    openCostList(index) {
      this.openedCostList[index] = true;
    }

    closeCostList(index) {
      this.openedCostList[index] = false;
    }

    showAddQuoteLine() {
      return !this.pricingTable.lines.some((line) => line.description === null);
    }

    addQuoteLine() {
      this.pricingTable.addLine({
        description: null,
        amount: null,
        price: null,
        discount: null,
        currency: this.pricingTable.currency,
      });
    }

    deleteQuoteLine(quoteLineIndex) {
      this.pricingTable.deleteLine(quoteLineIndex);
      if (this.pricingTable.lines.length === 0) this.addQuoteLine();
    }

    moveDownQuoteLine(quoteLineIndex) {
      this.pricingTable.downLine(quoteLineIndex);
    }

    moveUpQuoteLine(quoteLineIndex) {
      this.pricingTable.upLine(quoteLineIndex);
    }

    async saveTariff(quoteLine, lineIndex) {
      if (!this.isValidLine(lineIndex)) return;

      const tariff = new this.Tariff();
      tariff.setDataFromQuoteLine(quoteLine);
      await tariff.saveFromQuote();
      if (!quoteLine.from) quoteLine.from = tariff._id;
      this.$rootScope.$applyAsync();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.tariffSaved"),
      });
    }

    showMargin(quoteLine) {
      return !!quoteLine.costs.length;
    }

    deleteTax(index) {
      this.pricingTable.removeTax(index);
    }

    toggleSelectedByClient(quoteLine) {
      quoteLine.selectedByClient = !quoteLine.selectedByClient;
    }

    async addCost(quoteLine) {
      const cost = await this.ModalsManager.openCostModalPricing(false);

      if (!cost) {
        return;
      }

      quoteLine.addCostSnapshotFromCost(this.pricingTable.exchangeInfo.rates, cost);
    }

    async editCost(quoteLine, costToEdit) {
      const cost = await this.ModalsManager.openCostModalPricing(true, costToEdit);
      if (!cost) return;
      quoteLine.editCostSnapshotFromCost(this.pricingTable.exchangeInfo.rates, cost, costToEdit);
    }

    onCostDelete(quoteLine, cost) {
      quoteLine.removeCostSnapshot(this.pricingTable.exchangeInfo.rates, cost);
    }

    isDefaultCurrency(quoteLine, costCurrency) {
      return costCurrency === quoteLine.currency;
    }

    currencyExchange(quoteLine, currencyFrom, price, quantity) {
      const priceTotalBase = price * quantity;
      const currencyTo = quoteLine.currency;

      return this.Utils.getCurrencyNumberConverted(
        this.pricingTable.exchangeInfo.rates,
        currencyFrom,
        currencyTo,
        priceTotalBase,
      );
    }

    showSubtotal() {
      return this.pricingTable.taxes.length > 0;
    }

    getTotalCostsPricingTable() {
      let totalCostPricingTable = 0;

      this.pricingTable.lines.forEach((line) => {
        if (!line.selectable || (line.selectable && line.selectedByClient)) {
          line.costs.forEach((cost) => {
            if (this.isDefaultCurrency(line, cost.currency))
              totalCostPricingTable = totalCostPricingTable + cost.price * cost.amount * line.amount;
            else
              totalCostPricingTable =
                totalCostPricingTable +
                this.currencyExchange(line, cost.currency, cost.price, cost.amount) * line.amount;
          });
        }
      });

      return totalCostPricingTable;
    }

    getMarginPricingTable() {
      const marginPricingTable = this.Utils.calculateMarginFromPrice(
        this.getTotalCostsPricingTable(),
        this.pricingTable.getSubtotal(),
      );
      return `(${isNaN(marginPricingTable) ? 0 : marginPricingTable} %)`;
    }

    onPriceChange(quoteLine) {
      quoteLine.updateMargin(this.pricingTable.exchangeInfo.rates);
    }

    onCostChange(quoteLine) {
      quoteLine.updatePrice(this.pricingTable.exchangeInfo.rates);
    }

    onMarginChange(quoteLine) {
      quoteLine.updatePrice(this.pricingTable.exchangeInfo.rates);
    }

    async close() {
      if (this.form.$invalid) {
        this.wantExit = true;
        this.$rootScope.$applyAsync();
        this.onDismiss({ fromPricingTable: true });
      } else {
        this.onClose();
      }
    }
  },
};

export default PricingTableComponent;
